// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1PuzW","filesListContainer":"PosDisputesFiles_filesListContainer__3X6yn","filesButton":"PosDisputesFiles_filesButton__2pYo0"};